import * as types from './mutations-type'

const mutations = {
  [types.SET_NOW_TIME] (state, timestamp) {
    state.nowTime = timestamp
  },
  [types.INIT] (state) {
    state.pageInit = true
  },
  [types.SET_PAGE_LOADING] (state, loading) {
    state.pageLoading = loading
  },
  /**
   * 设置用户信息
   *************************************************
   * 已登录状态
   * loginUser = {
   *   "uid": "帐号 id",
   *   "avatar": "用户头像",
   *   "nickname": "名称"
   * }
   */
  [types.LOGIN] (state, user) {
    state.loginUser = user
  },
  [types.LOGOUT] (state) {
    state.loginUser = null
  },
  /**
   * 设置是否已到底部
   */
  [types.CHECK_BOTTOM] (state, toggle) {
    state.isBottom = toggle
  },
  /**
   * 设置是否是移动端
   */
  [types.CHECK_MOBILE] (state, mobile) {
    state.isMobile = mobile
  },
  [types.IS_ARTICLE_PAGE] (state, page) {
    state.isArticlePage = page
  },
  [types.SET_LAYOUT_NAV] (state, nav) {
    state.layoutNav = nav
  },
  [types.OFFLINE_MODAL_STATUS] (state, show) {
    state.offlineModalStatus = show
  },
  [types.SET_PHONE_LIST] (state, list) {
    state.phoneList = list
  },
  [types.SET_ACTIVITY_FORM_STATUS] (state, activityStatus) {
    state.activityStatus = activityStatus
  },
  /**
   * 有些需要登录的接口  登录成功回来之后 页面中的一些 需要做的一些事情
   */
  [types.SET_PAGE_ACTION] (state, pageAction) {
    state.pageAction = pageAction
  }
}

export default mutations
